import { fabric } from 'fabric';
import { getDarkOrLightColor } from '../helpers';
import extendCanvasGroupProps from './extendCanvasGroupProps';
import getUnitLabel from './getUnitLabel';

const TEXT_OFFSET = 0.05;

const addCanvasTriangle = (data, color, dropOnX, dropOnY, borderColor) => {
    data.unit = Number(data.unit);
    const size = 20;

    const triangle = new fabric.Triangle({
        left: dropOnX,
        top: dropOnY,
        width: size,
        height: size,
        fill: color,
        stroke: borderColor || 'transparent',
        strokeWidth: borderColor ? 1 : 0,
        selectable: false,
        hasRotatingPoint: false,
        originX: 'left',
        originY: 'top',
        imageSmoothingEnabled: false,
        noScaleCache: false,
        objectCaching: false
    });

    const textObject = new fabric.Text(getUnitLabel(data.unit), {
        fontFamily: 'Roboto, Arial, Sans-serif',
        fontWeight: 'normal',
        scaleY: 1 + TEXT_OFFSET,
        fontSize: 12 - TEXT_OFFSET,
        fill: getDarkOrLightColor(color || '', '#ffffff', '#000000'),
        type: 'text',
        attributeId: data.type,
        left: dropOnX + size / 2,
        top: dropOnY + size / 1.7,
        textAlign: 'center',
        originX: 'center',
        originY: 'center',
        selectable: false,
        imageSmoothingEnabled: false,
        noScaleCache: false,
        objectCaching: false
    });

    extendCanvasGroupProps();

    return new fabric.Group([triangle, textObject], {
        ...data,
        type: 'group',
        product: data.currentFiller || data.toxin,
        imageSmoothingEnabled: false,
        noScaleCache: false,
        objectCaching: false
    });
};

export default addCanvasTriangle;
